import React from 'react';
import TrainingWrapper from '../../../views/practice/training/TrainingWrapper';

const trainingRoutes = [
  {
    path: '/practice/training',
    element: <TrainingWrapper />
  }
];

export default trainingRoutes;
